import React from 'react';
import { Panel } from 'react-bootstrap';

import Event from '../shared/Event';

const EventPreview = ({ event }) => (
  <Panel>
    <Panel.Body>
      {event && <Event eventId={event.id} />}
      {!event && (
        <blockquote>
          Mouse over a job to see details here
        </blockquote>
      )}
    </Panel.Body>
  </Panel>
);

export default EventPreview;
